import React from "react";
import { Modal, Button, Form } from "semantic-ui-react";
import { Field, reduxForm } from "redux-form";
import { translate } from "react-i18next";
const RoomModalComponent = props => (
  <Modal open={props.isOpenModal} onActionClick={props.toggleModal}>
    <Modal.Header>
      {props.selected
        ? props.t("room:editRoomText")
        : props.t("room:addRoomButton")}
    </Modal.Header>
    <Modal.Content>
      <Modal.Description>
        <Form as="form" size="large" onSubmit={props.handleSubmit}>
          <Field
            name="name"
            type="text"
            component={Form.Input}
            fluid
            placeholder={props.t("room:roomNameText")}
          />

          <Field
            name="floor"
            type="text"
            component={Form.Input}
            fluid
            placeholder={props.t("room:roomFloorText")}
          />
          <Field
            name="roomGroupId"
            component={({ input }) => (
              <Form.Select
                options={props.roomGroups.map(group => ({
                  text: group.name,
                  value: group.roomGroupId
                }))}
                placeholder={props.t("room:roomTypePickerText")}
                onChange={(event, data) => input.onChange(data.value)}
                value={input.value}
              />
            )}
          />
          <Button color="blue" type="submit">
            {props.t("common:saveText")}
          </Button>
          <Button onClick={props.toggleModal}>
            {props.t("common:cancelText")}
          </Button>
        </Form>
      </Modal.Description>
    </Modal.Content>
  </Modal>
);

export const RoomModal = reduxForm({
  form: "rooms",
  enableReinitialize: true
})(translate("translations")(RoomModalComponent));



// WEBPACK FOOTER //
// ./src/rooms/RoomsList/RoomModal.js